<template>
  <div>
    <fragment v-if="$auth.user.village_subscription">
      <fragment v-if="isBtn">
        <v-btn
          fab
          data-testid="favoriteBtn"
          class="elevation-0"
          :color="isBtn ? 'secondary' : 'white'"
          @click.stop="toggleFavorite"
        >
          <v-icon large :color="bookmark.color">
            {{ bookmark.icon }}
          </v-icon>
        </v-btn>
      </fragment>
      <fragment v-else>
        <v-btn
          icon
          data-testid="favoriteBtn"
          :color="isBtn ? 'secondary' : 'white'"
          :large="large"
          @click.stop="toggleFavorite"
        >
          <v-icon :color="bookmark.color">
            {{ bookmark.icon }}
          </v-icon>
        </v-btn>
      </fragment>
    </fragment>
    <save-list-dialog
      v-if="open"
      :open="open"
      :resource-id="objectId"
      :category="category"
      @close="open = false"
      @added="onAdded"
    ></save-list-dialog>
    <item-saved-dialog
      :list-id="listId"
      :open="openSuccess"
      :resource-name="resourceHeadline"
      :list-name="listName"
      @close="openSuccess = false"
    ></item-saved-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ItemSavedDialog from './ItemSavedDialog.vue'
import SaveListDialog from './SaveListDialog.vue'

export default {
  name: 'Bookmark',
  components: {
    SaveListDialog,
    ItemSavedDialog,
  },
  props: {
    dark: {
      type: Boolean,
      default: false,
    },
    large: {
      type: Boolean,
      default: false,
    },
    objectId: {
      type: Number,
      default: null,
    },
    category: {
      type: String,
      default: 'activity',
    },
    isBtn: {
      type: Boolean,
      default: false,
    },
    resourceHeadline: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      open: false,
      openSuccess: false,
      listName: '',
      listId: '',
    }
  },
  computed: {
    ...mapState('user', {
      favorites: (state) => state.profile.favorites,
    }),
    isFavorite() {
      return (
        this.favorites &&
        this.favorites.some((fav) => fav.object_id === this.objectId)
      )
    },
    bookmark() {
      return this.isFavorite
        ? { icon: 'mdi-bookmark', color: this.isBtn ? 'white' : 'primary' }
        : { icon: 'mdi-bookmark-outline', color: this.dark ? 'white' : 'black' }
    },
    hasChangeListener() {
      return this.$listeners && this.$listeners.change
    },
  },
  methods: {
    openAppDownload() {
      this.$emit('change')
    },
    toggleFavorite() {
      if (this.hasChangeListener) {
        this.openAppDownload()
      } else if (this.isFavorite)
        this.$store.dispatch('user/FAVORITE/REQUEST', {
          action: 'remove',
          category: this.category,
          object_id: this.objectId,
        })
      else this.open = true
    },
    onAdded(data) {
      this.open = false
      this.listName = data.name
      this.listId = String(data.id)
      this.openSuccess = true
    },
  },
}
</script>
